<template>
  <!-- Modale de construction de collection -->
  <BaseModal
    v-if="isVisible"
    :title="
      $t('collections_and_merch.page.article_selector.modal.building.title')
    "
    :showActions="false"
    :closable="false"
    :showCancel="false"
    :showSubmit="false"
    submitText=""
    cancelText=""
    class="building-collection-modal"
  >
    <template #content>
      <div class="building-collection-content">
        <div class="building-animation">
          <div class="loading-spinner">
            <div class="spinner-circle"></div>
            <div class="spinner-circle spinner-circle-2"></div>
            <div class="spinner-circle spinner-circle-3"></div>
          </div>
        </div>
        <h3>
          {{
            $t(
              "collections_and_merch.page.article_selector.modal.building.message"
            )
          }}
        </h3>
        <p class="building-subtitle">
          {{ message }}
        </p>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from "@/components/ui/modals/BaseModal.vue";
import { mapState } from "vuex";

export default {
  name: "BuildingCollectionModal",
  components: {
    BaseModal,
  },
  computed: {
    ...mapState("merchandising-collections", {
      isVisible: (state) => state.isBuildingCollection,
      message: (state) => state.buildingCollectionMessage,
    }),
  },
};
</script>

<style scoped>
/* Styles pour la modale de construction de collection */
.building-collection-modal {
  z-index: 9999;
}

.building-collection-content {
  text-align: center;
  padding: 2rem;
}

.building-animation {
  margin-bottom: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
}

.building-animation .loading-spinner {
  position: relative;
  width: 60px;
  height: 60px;
  margin-bottom: 0;
  border: none;
}

.building-animation .spinner-circle {
  position: absolute;
  border: 3px solid transparent;
  border-top: 3px solid #4246de;
  border-radius: 50%;
  animation: spinModal 1.2s linear infinite;
}

.building-animation .spinner-circle {
  width: 60px;
  height: 60px;
}

.building-animation .spinner-circle-2 {
  width: 45px;
  height: 45px;
  top: 7.5px;
  left: 7.5px;
  border-top-color: #f73fde;
  animation-duration: 1s;
  animation-direction: reverse;
}

.building-animation .spinner-circle-3 {
  width: 30px;
  height: 30px;
  top: 15px;
  left: 15px;
  border-top-color: #19847b;
  animation-duration: 0.8s;
}

@keyframes spinModal {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.building-collection-content h3 {
  color: #2c3e50;
  font-size: 1.4rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.building-subtitle {
  color: #7f8c8d;
  font-size: 1rem;
  line-height: 1.5;
  margin: 0;
}

/* Animation d'apparition de la modale */
.building-collection-modal .modal-content {
  animation: buildingModalFadeIn 0.3s ease-out;
}

@keyframes buildingModalFadeIn {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
